// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__IR1sK","inputWrap":"Table_inputWrap__17daP","col":"Table_col__1omsU","bmiTooltip":"Table_bmiTooltip__3iDA_"};